import React, { useState } from 'react'
import { commaSeparator } from './utils';
import { ArrowLeftIcon, ArrowRightIcon, XCircleIcon } from '@heroicons/react/outline'

export default function Step2({ prevStep, nextStep, updateFieldValue, value }) {

    const [amount, setAmount] = useState(value);
    const [error, showError] = useState(false)


    const handleNextStep = () => {
        if (amount === "") {
            showError(true)
        } else {
            updateFieldValue("totalDebt", amount)
            nextStep(2)
        }
    }

    const handleForward = (v) => {
        setAmount(v)
        updateFieldValue("totalDebt", v)
        nextStep(2)
    }


    return (

        <div id="step2">
            <div className='max-w-lg mx-auto p-10'>
                <fieldset>
                    <legend className='font-normal text-base px-6'>How much do you estimate you owe in back taxes?</legend>
                    <div className='mt-5 ml-2 text-base text-gray-800'>
                        <div className='py-1'>
                            <input type="radio" id="totalDebt-1" defaultChecked={value === '$1 - $4,999'} onClick={() => handleForward("$1 - $4,999")} name="how_much_do_you_estimate_you_owe_in_back_taxes_" value="$1 - $4,999" />
                            <label htmlFor="totalDebt-1" className='ml-2'>$1 - $4,999</label>
                        </div>
                        <div className='py-1'>
                            <input type="radio" id="totalDebt-2" defaultChecked={value === '$5,000 - $9,999'} onClick={() => handleForward("$5,000 - $9,999")} name="how_much_do_you_estimate_you_owe_in_back_taxes_" value="$5,000 - $9,999" />
                            <label htmlFor="totalDebt-2" className='ml-2'>$5,000 - $9,999</label></div>
                        <div className='py-1'>
                            <input type="radio" id="totalDebt-3" defaultChecked={value === '$10,000 - $29,999'} onClick={() => handleForward("$10,000 - $29,999")} name="how_much_do_you_estimate_you_owe_in_back_taxes_" value="$10,000 - $29,000" />
                            <label htmlFor="totalDebt-3" className='ml-2'>$10,000 - $29,999</label></div>
                        <div className='py-1'>
                            <input type="radio" id="totalDebt-4" defaultChecked={value === '$30,000 - $49,999'} onClick={() => handleForward("$30,000 - $49,999")} name="how_much_do_you_estimate_you_owe_in_back_taxes_" value="$30,000 - $49,999" />
                            <label htmlFor="totalDebt-4" className='ml-2'>$30,000 - $49,999</label></div>
                        <div className='py-1'>
                            <input type="radio" id="totalDebt-5" defaultChecked={value === '$50,000 or more'} onClick={() => handleForward("$50,000 or more")} name="how_much_do_you_estimate_you_owe_in_back_taxes_" value="$50,000 or more" />
                            <label htmlFor="totalDebt-5" className='ml-2'>$50,000 or more</label></div>


                    </div>
                </fieldset>
                {
                    error &&
                    <p className="mt-2 mb-0 text-xs text-red-500 flex">
                        <XCircleIcon className="h-4 w-4 mr-1" /> Please select a value.
                    </p>
                }
            </div>
            <div className="relative flex items-center justify-between w-full h-14 bg-blue-600 rounded-b-md">
                {prevStep && <button
                    id="calcStep2Prev"
                    onClick={() => prevStep(2)}
                    className="flex items-center h-full w-fit hover:bg-blue-800 rounded-bl-md text-white text-base px-5 py-1.5 font-semibold uppercase">
                    <ArrowLeftIcon className='h-5 w-5 mr-2' /> <span className="hidden md:block">Prev</span>
                </button>}

                {/* Centered Step Counter */}
                <div className="absolute left-1/2 -translate-x-1/2 text-white opacity-50">
                    2 of 12
                </div>

                {/* Next Button */}
                <button
                    id="calcStep2Next"
                    onClick={() => handleNextStep()}
                    className="flex items-center h-full px-5 font-semibold text-white uppercase bg-blue-600 rounded-br-md hover:bg-blue-800"
                >
                    <span className="hidden md:block">Next</span>
                    <ArrowRightIcon className="w-5 h-5 ml-2" />
                </button>
            </div>
        </div>
    );
}